import { extensionsConfig } from "client/config/extensionsConfig";
import { useDeviceUpload } from "client/hooks/upload/useDeviceUpload";
import { useGoogleAnalytics } from "client/hooks/utils/useGoogleAnalytics";
import { HandleFile } from "client/types/HandleFile";
import { getRandomId } from "client/utils/getRandomId";
import { loadImage } from "client/utils/imageEdit/loadImage";
import { translateFunc } from "client/utils/translateFunc";
import { DEFAULT_TOAST_SHOW_TIME } from "components/common/Toast/ToastRenderer";
import { useToast } from "components/common/Toast/useToast";
import type { MemeTemplate } from "types/meme";
import { useSelectMeme } from "../MemesList/useSelectMeme";

export const useMemeDeviceUpload = () => {
    const { handleSelectMeme } = useSelectMeme();
    const { gtag } = useGoogleAnalytics();
    const toast = useToast();
    const errorFromEditorText = translateFunc(`common:corrupt-image-toast-test`);

    const handleFile: HandleFile = async (files) => {
        const file = files[0];
        if (!file) return null;
        gtag("event", "upload_meme", {
            page: "meme generator",
        });
        const url = URL.createObjectURL(file.file);
        const { width, height, error: error } = await loadImage(url);
        if (error) {
            toast.toast({
                closeable: true,
                position: "top-right",
                status: "error",
                text: errorFromEditorText,
                time: DEFAULT_TOAST_SHOW_TIME,
            });
            return;
        }
        const meme: MemeTemplate = {
            id: `${parseInt(getRandomId())}`,
            siteUrl: "local",
            siteId: "local",
            slugKey: file.file.name,
            title: file.file.name,
            description: file.file.name,
            imageUrl: url,
            thumbnailUrl: url,
            settings: {
                width,
                height,
                textBoxes: [],
            },
            isTransparent: false,
            createdAt: new Date().getTime(),
        };
        handleSelectMeme(meme);
    };
    const { handleClick } = useDeviceUpload(
        handleFile,
        {
            allowMultiple: false,
            supportedExtensions: extensionsConfig["meme-generator"],
        },
        "mg-file-input",
    );
    return { handleMemeDeviceUpload: handleClick };
};
